export default __webpack_public_path__ + "static/27001-7b9e71b33fd234a218c9d98ff4847865.png";